<template>
  <div>
    <v-card dark flat class="card-background" tile elevation="4">
      <div class="center-div">
        <v-col cols="12" md="12" sm="12">
          <v-img
            src="/img/fantasy_lineups_logo.png"
            class="logo mx-auto"
            height="50"
            width="350"
            contain
          />
        </v-col>

        <v-col cols="12" md="12" sm="12">
          <v-img
            src="/img/checked.png"
            class="logo mx-auto"
            height="50"
            width="50"
            contain
          />
        </v-col>

        <v-col cols="12" md="5" sm="5" class="mx-auto">
          <p class="text-center ml-4 font-weight-medium subtitle-1">
            You’re one step closer to using FantasyLineups.com. <br />
            Please Check Your Email to continue.
          </p>
        </v-col>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "conversionPage",

  mounted() {
    console.log("verifyquery", this.$route);
  },

  computed: {
    ...mapState("userModule", ["verifyStatus"]),
  },

  mounted() {
    this.GoogleAnalytic();
    this.GoogleAds();
    window.fbq("track", "Purchase");
  },

  methods: {
    GoogleAnalytic() {
      this.$gtag.config("UA-204063830-2"); //G-measurement-Id
    },

    GoogleAds() {
      this.$gtag.config("AW-323506423");
      this.$gtag.pageview({ page_path: "/freeuser/success" });

      // prettier-ignore
      this.$gtag.event('conversion', {'send_to': 'AW-323506423/5-zbCMr-1uICEPehoZoB',value:1});
    },
  },

  beforeRouteEnter(to, from, next) {
    if (localStorage.getItem("status") == "active") {
      next({ name: "NbaLayout" });
    } else if (localStorage.getItem("status") == "Inactive") {
      next("/login");
    } else {
      next();
    }
  },
};
</script>

<style scoped>
.card-background {
  min-height: 100vh;
}

.center-div {
  padding: 10% 0;
}
</style>
